import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class GambleRequestPayload extends RequestPayload {
    public choice?: string;
    public id: number;
}
